import styles from './WelcomeScreenOne.module.scss';
import { t } from 'i18next';

function WelcomeScreenOne() {
  return (
    <div className={styles.screenContent}>
      <h3 className={styles.heading}>{t('WELCOME')}</h3>
      <p className={styles.body}>{t('WELCOME_MESSAGE_ONE')}</p>
    </div>
  );
}

export default WelcomeScreenOne;
